<template>
  <div id="live_list">
    <div class="bread">
      <el-breadcrumb>
        <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index" :to="item.to">
          {{ item.label }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户聊天记录</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="back" @click="backPage()">返回</div>
    </div>
    <div class="bottom cont">
      <div class="titlebox">
        <div class="title">用户聊天记录</div>
        <div class="notice">
          <span class="right_grid">
            <span class="refresh" @click="refresh">刷新</span>
          </span>
        </div>
      </div>
      <div class="string"></div>
      <div class="navs">
        <el-form class="course_search_form" ref="course_search_form" size="large">
          <el-form-item label="unionid">
            <el-input v-model="search.unionid" placeholder="请输入 unionid" style="width: 300px" :disabled="!!urlUnionid"></el-input>
          </el-form-item>
          <el-form-item label="直播间ID" style="margin-left: 16px;">
            <el-input v-model="search.livingid" placeholder="请输入 livingid" style="width: 230px" :disabled="!!urlLivingid"></el-input>
          </el-form-item>
          <el-form-item label="消息类型" style="margin-left: 16px;">
            <el-select v-model="search.tag" style="width: 180px" @change="onTagChange">
              <el-option label="全部" value=""></el-option>
              <el-option label="我发送的" value="self"></el-option>
              <el-option label="我被@的" value="at_me"></el-option>
              <el-option label="指定接收我的" value="target_me"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 16px;">
            <el-button type="primary" @click="getData">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表 -->
      <div class="table_box">
        <el-table v-loading="loading" :data="tableData" stripe style="width: 98%; margin: 0 auto;" :height="tableHeight"
          :header-cell-style="{backgroundColor: '#FAFAFA'}">
          <el-table-column label="序号" width="60" align="center" fixed="left">
            <template #default="scope">
              <span>{{ scope.$index + 1 + (page.current - 1) * page.size }}</span>
            </template>
          </el-table-column>
          <el-table-column label="消息类型" width="120" align="center" fixed="left">
            <template #default="scope">
              <el-tag v-for="tag in scope.row.tags" :key="tag" :type="getTagType(tag)" size="small" style="margin-right: 4px;">
                {{ getTagLabel(tag) }}
              </el-tag>
              <span v-if="!scope.row.tags || scope.row.tags.length === 0">-</span>
            </template>
          </el-table-column>
          <el-table-column label="发送时间" width="160" align="center" fixed="left">
            <template #default="scope">
              <span>{{ scope.row.date_time || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发送者" width="180" align="left" :show-overflow-tooltip="true">
            <template #default="scope">
              <div style="display: flex; align-items: center;">
                <img v-if="scope.row.avatar" :src="scope.row.avatar" style="width: 28px; height: 28px; border-radius: 50%; margin-right: 8px;" />
                <span>{{ scope.row.nickname || scope.row.wx_union_id || '-' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="接收方" width="180" align="left" :show-overflow-tooltip="true">
            <template #default="scope">
              <span v-if="scope.row.accept_name === 'all'" style="color: #909399;">全体</span>
              <span v-else>{{ scope.row.accept_name || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="消息内容" align="left" :show-overflow-tooltip="true">
            <template #default="scope">
              <div>
                <div v-if="scope.row.text_content || scope.row.barrage_txt" style="word-break: break-all;">
                  <span>{{ scope.row.text_content || scope.row.barrage_txt }}</span>
                </div>
                <div v-if="scope.row.at_list && scope.row.at_list.length > 0" style="margin-top: 4px; color: #1890FF; font-size: 12px;">
                  @用户：
                  <el-tag v-for="(at, idx) in scope.row.at_list" :key="idx" size="small" type="info" style="margin-right: 4px;">
                    {{ at.nick_name || at.account_id }}
                  </el-tag>
                </div>
                <div v-if="scope.row.image_urls && scope.row.image_urls.length > 0" style="margin-top: 4px;">
                  <img v-for="(img, idx) in scope.row.image_urls" :key="idx" :src="img" style="width: 40px; height: 40px; margin-right: 4px; border-radius: 4px;" />
                </div>
                <div v-if="scope.row.reply_msg && scope.row.reply_msg.nick_name" style="margin-top: 4px; padding: 4px 8px; background-color: #f5f7fa; border-radius: 4px; font-size: 12px; color: #606266;">
                  回复 {{ scope.row.reply_msg.nick_name }}：{{ scope.row.reply_msg.content ? (scope.row.reply_msg.content.text_content || '') : '' }}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row class="paging_box" justify="space-between">
          <el-pagination class="paging" @size-change="sizeChange" @current-change="currentChange"
            :current-page="page.current" :page-sizes="page.pageSizes" :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import './assets/less/list.less';
  import list_model from "./model/model";
  var that = null
  export default {
    components: {  },
    data() {
      that = this
      return {
        urlUnionid: that.$route.query.unionid || '',
        urlLivingid: that.$route.query.livingid || '',
        // 上级来源路径，例如 'info' 表示从员工数据(info.vue)跳转过来
        fromPath: that.$route.query.from || '',
        // 上级页面传入的原始 query 参数（用于返回时还原）
        fromQuery: {},
        // 面包屑数据
        breadcrumbList: [],
        loading: false,
        tableHeight: 350,
        tableData: [],
        page: {
          loading: false,
          pageSize: 20,
          total: 0,
          size: 20,
          current: 1,
          pageSizes: [10, 20, 50, 100],
        },
        search: {
          unionid: that.$route.query.unionid || '',
          livingid: that.$route.query.livingid || '',
          tag: ''
        },
        // 全部数据（用于本地筛选）
        allData: []
      }
    },
    mounted() {
      // 初始化前判断登录态缓存，不存在则跳回列表页
      if (!localStorage.getItem('fallback_ywy_user')) {
        that.$router.replace('/course_list')
        return
      }
      // 收集上级页面传入的 query 参数（除内部使用参数外）
      const internalKeys = ['unionid', 'livingid', 'from']
      const allQuery = that.$route.query || {}
      for (const key in allQuery) {
        if (internalKeys.indexOf(key) === -1) {
          that.fromQuery[key] = allQuery[key]
        }
      }
      // 构建面包屑
      that.buildBreadcrumb()
      that.$nextTick(() => {
        that.tableHeight = document.querySelector('.table_box').clientHeight - 34;
        // 优先从 URL 参数自动查询
        if (that.urlUnionid && that.urlLivingid) {
          that.getData()
        }
      });
    },
    methods: {
      /**
       * 根据 from 参数构建面包屑导航
       * 支持的上级来源：
       *   - info  : 员工数据(info.vue)
       *   - watch_index : 缴费客户观看直播情况(watch_index.vue)
       */
      buildBreadcrumb() {
        const list = []
        const query = that.fromQuery || {}
        if (that.fromPath === 'info') {
          // info.vue 的面包屑：直播列表 > 组别数据 > 组内数据 > 员工数据
          list.push({
            label: '直播列表',
            to: { path: '/course_list', query: { type: query.type || '' } }
          })
          list.push({
            label: '组别数据',
            to: {
              path: '/course',
              query: {
                liveId: query.liveId || that.urlLivingid || '',
                type: query.type || '',
                livetype: query.livetype || ''
              }
            }
          })
          list.push({
            label: '组内数据',
            to: {
              path: '/course_detail',
              query: {
                liveId: query.liveId || that.urlLivingid || '',
                bmbm: query.bmbm || '',
                type: query.type || '',
                date: query.date || '',
                livetype: query.livetype || ''
              }
            }
          })
          list.push({
            label: '员工数据',
            to: {
              path: '/course_info',
              query: { ...query }
            }
          })
        } else if (that.fromPath === 'watch_detail') {
          list.push({
            label: '缴费客户观看直播情况',
            to: { path: '/watch_index' }
          })
          list.push({
            label: '缴费客户观看直播明细',
            to: { path: '/watch_detail', query: { ...query } }
          })
        } else {
          // 默认入口（直接 URL 访问）
          list.push({
            label: '缴费客户观看直播情况',
            to: { path: '/watch_index' }
          })
        }
        that.breadcrumbList = list
      },
      /**
       * 返回上一级页面
       */
      backPage() {
        if (that.fromPath === 'info' && Object.keys(that.fromQuery).length > 0) {
          that.$router.push({
            path: '/course_info',
            query: { ...that.fromQuery }
          })
        } else if (that.fromPath === 'watch_detail') {
          that.$router.push({
            path: '/watch_detail',
            query: { ...that.fromQuery }
          })
        } else {
          that.$router.push('/watch_index')
        }
      },
      /**
       * 标签类型映射（Element Plus tag type）
       */
      getTagType(tag) {
        const map = {
          'self': 'success',
          'at_me': 'warning',
          'target_me': 'danger'
        }
        return map[tag] || 'info'
      },
      /**
       * 标签显示文字
       */
      getTagLabel(tag) {
        const map = {
          'self': '我发送',
          'at_me': '被@',
          'target_me': '指定我'
        }
        return map[tag] || tag
      },
      /**
       * 消息类型筛选变化
       */
      onTagChange() {
        that.applyLocalFilter()
      },
      /**
       * 本地按 tag 过滤
       */
      applyLocalFilter() {
        const tag = that.search.tag
        if (!tag) {
          that.tableData = that.allData
        } else {
          that.tableData = that.allData.filter(item => item.tags && item.tags.indexOf(tag) > -1)
        }
      },
      /**
       * 拉取聊天记录
       */
      getData() {
        if (!that.search.unionid || !that.search.livingid) {
          that.$message.warning('请先填写 unionid 和 livingid')
          return
        }
        that.loading = true;
        let params = {
          unionid: that.search.unionid,
          livingid: that.search.livingid,
          page: that.page.current,
          page_size: that.page.size
        }
        list_model.get_chat_records(params).then(res => {
          that.loading = false;
          if (res.code === 0) {
            that.allData = res.list || []
            // 应用本地筛选
            that.applyLocalFilter()
          } else {
            that.$message.error(res.message || '查询失败')
          }
        }).catch(err => {
          that.loading = false;
          that.$message.error('请求失败: ' + (err && err.message ? err.message : err))
        })
      },
      /* 数据刷新 */
      refresh() {
        that.getData()
      },
      /**
       * 重置搜索条件
       */
      resetSearch() {
        that.search.unionid = that.urlUnionid
        that.search.livingid = that.urlLivingid
        that.search.tag = ''
        that.page.current = 1
        if (that.search.unionid && that.search.livingid) {
          that.getData()
        }
      },
      /**
       * 分页-改变分页大小
       */
      sizeChange(v) {
        that.page.size = v;
        that.page.current = 1;
        that.getData();
      },
      /**
       * 分页-当前页数据刷新
       */
      currentChange(v) {
        that.page.current = v;
        that.getData();
      }
    }
  }
</script>

<style>
  * {
    padding: 0;
  }
</style>
